module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-bb-movie-sample-1bbe898f341a42561cb2b594f68890d2.jpg";